export const SPORTSBOOK_HISTORY_PAGE_LIMIT = 10;
export const SPORTSBOOK_HISTORY_HIDDEN_FILL_MAX_REQUESTS = 4;
export const SPORTSBOOK_HISTORY_HIDDEN_FILL_MAX_ROWS = 40;
export const SPORTSBOOK_HISTORY_OPTIMISTIC_MAX_ROWS = 20;
export const SPORTSBOOK_HISTORY_OPTIMISTIC_TTL_MS = 5 * 60 * 1000;
export const SPORTSBOOK_HISTORY_OPTIMISTIC_EVENT = 'sportsbook-history:optimistic-row';
export const SPORTSBOOK_HISTORY_OPTIMISTIC_STORAGE_KEY = 'casino_app_sportsbook_history_optimistic_v1';
export const SPORTSBOOK_HISTORY_HIDDEN_STORAGE_KEY = 'casino_app_hidden_sportsbook_history_id_v1';

export const isSportsbookUnifiedHistoryEnabled = (environment = process.env) =>
  environment?.REACT_APP_SPORTSBOOK_UNIFIED_HISTORY_ENABLED !== 'false';
